module.exports = __webpack_public_path__ + "static/media/InfoIcon.9d08a3a1.svg";